import { useNavigate, useLocation } from "react-router-dom";

export function useRemoveQueryParam(paramsToDelete: string[]) {
  const navigate = useNavigate();
  const location = useLocation();

  const removeQueryParam = () => {
    const params = new URLSearchParams(location.search);

    paramsToDelete.forEach((param) => {
      params.delete(param);
    });

    navigate(
      {
        pathname: location.pathname,
        search: params.toString(),
      },
      { replace: true }
    );
  };

  return removeQueryParam;
}
